module.exports = __webpack_public_path__ + "assets/img/num2.98dc4c21.png";